import { useEffect, useState } from 'react';

import { dataLayerPush } from 'utils/functions';

interface ErrorInfo {
  message: string;
  source: string;
  error: Error | null;
}

function useErrorBoundary() {
  const [error, setError] = useState<ErrorInfo | null>(null);

  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      setError({
        message: event.message,
        source: event.filename,
        error: event.error,
      });
    };

    window.addEventListener('error', handleError);

    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  useEffect(() => {
    if (error) {
      dataLayerPush('page_error', 'event', {
        event_category: 'page_error',
        event_action: 'error',
        event_label: error.message,
        error: error,
      });
    }
  }, [error]);

  return { error };
}

export default useErrorBoundary;
